import { Link } from '@tanstack/react-router';
import { Anchor, Box, Button, Container, Group, Text, Title } from '@mantine/core';
import type { ReactNode } from 'react';

/**
 * Shared shell for the public marketing surface (`/`, `/about`,
 * `/features`, `/pricing`, `/contact`). Keeps the nav + footer
 * consistent and lets each page focus on its own content.
 */
export function PublicShell({ children }: { children: ReactNode }) {
  return (
    <Box>
      <Box
        component="nav"
        style={{
          borderBottom: '1px solid var(--mantine-color-gray-2)',
          background: 'white',
        }}
      >
        <Container size="lg" py="sm">
          <Group justify="space-between">
            <Anchor component={Link} to="/" underline="never">
              <Title order={4}>LeadSync</Title>
            </Anchor>
            <Group gap="lg" visibleFrom="sm">
              <Anchor component={Link} to="/features" underline="never" c="dark">
                Features
              </Anchor>
              <Anchor component={Link} to="/pricing" underline="never" c="dark">
                Pricing
              </Anchor>
              <Anchor component={Link} to="/about" underline="never" c="dark">
                About
              </Anchor>
              <Anchor component={Link} to="/contact" underline="never" c="dark">
                Contact
              </Anchor>
            </Group>
            <Group>
              <Button component={Link} to="/auth/login" variant="default" size="sm">
                Sign in
              </Button>
              <Button component={Link} to="/auth/register" size="sm">
                Get started
              </Button>
            </Group>
          </Group>
        </Container>
      </Box>

      <Box>{children}</Box>

      <Box
        mt="xl"
        style={{ borderTop: '1px solid var(--mantine-color-gray-2)', background: 'white' }}
      >
        <Container size="lg" py="md">
          <Group justify="space-between" wrap="wrap">
            <Text size="sm" c="dimmed">
              © {new Date().getFullYear()} LeadSync.
            </Text>
            <Group gap="md">
              <Anchor component={Link} to="/legal/privacy" size="sm" c="dimmed">
                Privacy
              </Anchor>
              <Anchor component={Link} to="/legal/terms" size="sm" c="dimmed">
                Terms
              </Anchor>
              <Anchor component={Link} to="/legal/data-deletion" size="sm" c="dimmed">
                Data deletion
              </Anchor>
              <Anchor component={Link} to="/contact" size="sm" c="dimmed">
                Contact
              </Anchor>
            </Group>
          </Group>
        </Container>
      </Box>
    </Box>
  );
}
